import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useParams} from 'react-router-dom';
import {baseUrl, formatDateTime} from '../../Univ.js'
function NursePatView(props) {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const pat_id = ipData.map(row => row.pat.pat_id);
    return (
        <section className="container mt-4">
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip_id}</td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                        <div className="col-md-12 company-info">
                            <div className="panel panel-primary">
                                <div className="panel-heading">
                                    <h4 className="panel-title">InPatient Nursing</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 company-info mb-3">
                            <div className="btn-group">
                                <Link to={`/nurse-notes/${ip_id}/`} className="btn btn-primary">Nurse Notes</Link></div>
                            <div className="btn-group">
                                <Link to={`/vital-sign/${ip_id}/`} className="btn btn-primary ms-2">Vital Signs</Link>
                            </div>
                            <div className="btn-group">
                                <Link to={`/diet-detail/${ip_id}/`} className="btn btn-primary ms-2">Diet Details</Link>
                            </div>
                            <div className="btn-group">
                                <Link to={`/consult-notes/${ip_id}/`} className="btn btn-primary ms-2">Consultant
                                    Notes</Link></div>
                            <div className="btn-group">
                                <Link to={`/ip-lab-entry/${pat_id}/${ip_id}/`} className="btn btn-primary ms-2">Lab
                                    Request</Link></div>
                            <div className="btn-group">
                                <Link to={`/ip-inv-entry/${pat_id}/${ip_id}/`} className="btn btn-primary ms-2">Radiology
                                    Request</Link></div>
                            <div className="btn-group">
                                <Link to={`/ip-drug-entry/${pat_id}/${ip_id}/`} className="btn btn-primary ms-2">Drug
                                    Request</Link></div>
                            <div className="btn-group">
                                <Link to={`/ip-drug-use/${pat_id}/${ip_id}/`} className="btn btn-primary ms-2">Drug
                                    Chart</Link></div>
                            <div className="btn-group">
                                <Link to={`/insulin/${ip_id}/`} className="btn btn-primary ms-2">Insulin</Link></div>
                            <div className="btn-group">
                                <Link to={`/respirate/${ip_id}/`} className="btn btn-primary ms-2">Respiration
                                    System</Link></div>
                            <div className="btn-group">
                                <Link to={`/fluid/${ip_id}/`} className="btn btn-primary ms-2">Fluid Balance</Link>
                            </div>
                            <div className="btn-group">
                                <Link to={`/positioning/${ip_id}/`} className="btn btn-primary ms-2">Positioning</Link>
                            </div>
                            <div className="btn-group">
                                <Link to={`/chest-physio/${ip_id}/`} className="btn btn-primary ms-2">Chest
                                    Physio</Link></div>
                            <div className="btn-group">
                                <Link to={`/pupils/${ip_id}/`} className="btn btn-primary ms-2">Pupils</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default NursePatView;